/* eslint-disable prefer-destructuring */
import * as marietta3d from '..';
import * as marietta from '../../marietta';
import { StartsQuotationList } from '../AutoGen/StartsQuotationList';

export default class ApiRequest {
  private autoGen: marietta3d.AutoGen.AutoBase;

  constructor(aGen: marietta3d.AutoGen.AutoBase) {
    this.autoGen = aGen;
  }

  /*------------------------------------------------------
  * [ASP] 建具選択リスト Request
  */
  // public ReqFittingList(cbs: Function, cbe: Function) {
  //     // リクエスト用データ
  //     var reqXML = this.autoGen.reqXML();
  //     var aData: marietta3d.AutoGen.autoBase = this.autoGen;
  //     this.webRequest('FittingList', reqXML, cbs, cbe);
  // }

  /*------------------------------------------------------
  * [ASP] 建具サイズリスト Request
  */
  public ReqFittingSizeList(cbs: Function, cbe: Function, fitIdx: string, all: string, type: string) {
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    aData.fittingSizeListTarget = fitIdx;
    aData.fittingSizeListType = type;
    aData.fittingSizeListAll = all;
    // リクエスト用データ
    const reqXML = aData.reqXML();
    this.webRequest('FittingSizeList', reqXML, cbs, cbe);
  }

  /*------------------------------------------------------
  * [ASP] 建具サイズリスト Request
  */
  public ReqFittingSizeDefault(cbs: Function, cbe: Function, fitIdx: string, type: string) {
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    aData.fittingSizeListTarget = fitIdx;
    aData.fittingSizeListType = type;
    // リクエスト用データ
    const reqXML = aData.reqXML();
    this.webRequest('FittingSizeDefault', reqXML, cbs, cbe);
  }

  /*------------------------------------------------------
  * [ASP] 自動建具 Request
  */
  public ReqFittingGen(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    // リクエストの結果、戻ってきたJsonの読み込み用クロージャ
    const success = (jsonData: any) => {
      if (jsonData != null) {
        // 部屋読み込み
        const room = jsonData.room;
        if (room != null) {
          const itemList = room[0].item;
          if (itemList != null) {
            if (itemList.length > 0) {
              aData.InitHeyaList();// 部屋初期化
              aData.InitWallList();// 壁初期化
              aData.readHeya(itemList, (jsonData.building_type || null));
              // this.autoGen.AddKaidan();// 下の階の階段を、吹き抜けとして当階に追加
              // this.autoGen.MakeWall();// 壁作成
              // this.autoGen.planInfo();// 建物面積情報の更新
            }
          }
        }
        // 建具読み込み
        const fit = jsonData.fitting;
        if (fit != null) {
          aData.InitFittingList();// 建具初期化
          aData.readTategu(fit, (jsonData.building_type || null));
        }
        cb(aData.FittingList, '');
        // this.autoGen.draw();
      }
    };
    const unsuccess = (msg: string) => {
      aData.InitFittingList();// 建具初期化
      cb(aData.FittingList, msg);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/generate_fitting', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] 自動住設 Request
  */
  public ReqEquipmentGen(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    // リクエストの結果、戻ってきたJsonの読み込み用クロージャ
    const success = (jsonData: any) => {
      if (jsonData != null) {
        // 住設読み込み
        const equ = jsonData.equipment;
        if (equ != null) {
          if (equ.length > 0) {
            // 住設初期化
            aData.InitEquipmentList();
            aData.readJyusetu(equ, (jsonData.building_type || null));
          }
        }
        cb(aData.EquipmentList, '');
        // this.autoGen.draw();
      }
    };
    const unsuccess = (msg: string) => {
      aData.InitEquipmentList();// 住設初期化
      cb(aData.EquipmentList, msg);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/generate_equipment', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] 廊下自動 Request
  */
  public ReqHallwayGen(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;

    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (jsonData: any) => {
      aData.InitHeyaList();// 部屋初期化
      aData.InitWallList();// 壁初期化
      aData.InitFittingList();// 建具初期化

      if (jsonData != null) {
        // 部屋読み込み
        const room = jsonData.room;
        if (room != null) {
          if (room.length > 0) {
            aData.readHeya(room, (jsonData.building_type || null));
          }
        }
        // 建具読み込み
        const fit = jsonData.fitting;
        if (fit != null) {
          aData.readTategu(fit, (jsonData.building_type || null));
        }
        const ary = [];
        ary.push([]);
        ary.push([]);
        ary.push([]);
        for (let fcnt = 0; fcnt < 3; fcnt += 1) {
          for (let i = 0; i < aData.HeyaList[fcnt].length; i += 1) {
            const h: marietta3d.AutoGen.object.AutoObjRoom = aData.HeyaList[fcnt][i];
            if (h.IsHallway() === true) {
              // if ( h.original == "0" ) { // "1"の場合は元々あった廊下
              ary[fcnt].push(h.points);
              // }
            }
          }
        }
        cb(ary, '');
        // this.autoGen.draw();
      }
    };
    const unsuccess = (msg: string) => {
      aData.InitHeyaList();// 部屋初期化
      aData.InitWallList();// 壁初期化
      aData.InitFittingList();// 建具初期化
      const dmy = [];
      dmy.push([]);
      dmy.push([]);
      dmy.push([]);
      cb(dmy, msg);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/generate_hallway', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] 廊下生成が必要か？ＣＨＥＣＫ Request
  */
  public ReqCheckHallway(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    // リクエストの結果、戻ってきたJSONの読み込み用クロージャ
    const success = (jsonData: any) => {
      aData.InitHeyaList(); // 部屋初期化
      aData.InitWallList(); // 壁初期化
      aData.InitFittingList(); // 建具初期化
      if (jsonData != null) {
        // 結果読み込み
        let flag = false;
        const checkHallway = jsonData.check_hallway_response;
        if (checkHallway) {
          flag = true;
        }
        cb(flag);
      }
    };
    const unsuccess = () => {
      cb(false);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/check_hallway', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] 外周が複数に分かれているか？ＣＨＥＣＫ Request
  */
  public ReqOutDivideCheck(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (jsonData: any) => {
      aData.InitHeyaList(); // 部屋初期化
      aData.InitWallList(); // 壁初期化
      aData.InitFittingList(); // 建具初期化
      if (jsonData != null) {
        // 結果読み込み
        let flag = false;
        const checkHallway = jsonData.check_outdivide_response;
        if (checkHallway) {
          flag = true;
        }
        cb(flag);
      }
    };
    const unsuccess = () => {
      cb(false);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/check_outdivide', reqJson, success, unsuccess);
  }

  /*-----------------------------------------------------
  * [ASP] 壁リストを取得
  */
  public ReqMakeRoomWall(cb: Function) {
    console.log('Start make room wall');
    // リクエスト用データ
    // const reqXML = this.autoGen.reqXML();
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    // const aData: marietta3d.AutoGen.autoBase = this.autoGen;

    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (xmlDoc: Document) => {
      if (xmlDoc != null) {
        cb(xmlDoc);
        console.log('Success make room wall');
      }
    };
    const unsuccess = () => {
      console.log('make room wall failed...');
      cb(null);
    };
    this.webRequest('api/edit_wall', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] Export
  */
  public ReqExportFile(cb: Function) {
    // リクエスト用データ
    const reqXML = this.autoGen.reqXML();
    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (xmlDoc: Document) => {
      if (xmlDoc != null) {
        // let stat: string = '';
        let path: string = '';
        const exp = xmlDoc.getElementsByTagName('export');
        if (exp.length > 0) {
          path = exp[0].textContent;
          // const elem = exp[0].getElementsByTagName('status');
          // if (elem.length > 0) {
          //   stat = elem[0].textContent;
          // }
        }
        cb(path);
      }
    };
    const unsuccess = () => {
      // var exp = xmlDoc.getElementsByTagName( 'export' );
      cb('');
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('export', reqXML, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] Area info
  */
  public ReqPlanArea(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;

    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (jsonData: any) => {
      if (jsonData != null) {
        aData.InitAreaInfo(); // 初期化
        // Info 読み込み
        const info = jsonData.info;
        if (info !== undefined && info !== null) {
          aData.koujiMenseki[1] = Number(info.plan_koujimenseki_1);
          aData.koujiMenseki[2] = Number(info.plan_koujimenseki_2);
          aData.koujiMenseki[3] = Number(info.plan_koujimenseki_3);

          aData.yukaMenseki[1] = Number(info.plan_yukamenseki_1);
          aData.yukaMenseki[2] = Number(info.plan_yukamenseki_2);
          aData.yukaMenseki[3] = Number(info.plan_yukamenseki_3);

          aData.maguchi = Number(info.frontage);
          aData.okuyuki = Number(info.depth);
          aData.genkanhoko = Number(info.entrance);
          aData.roomCount = Number(info.rooms);
          aData.planSizeX = Number(info.plansizex);
          aData.planSizeY = Number(info.plansizey);
          if (info.roomstype !== undefined && info.roomstype !== null) {
            aData.roomType = info.roomstype;
          }
        }
        if (cb != null) {
          const pinfo = new marietta3d.AutoGen.PlanAreaInfo();
          for (let i = 0; i < aData.maxFloor; i += 1) {
            pinfo.yukaMenseki[i + 1] = aData.yukaMenseki[i + 1];
            pinfo.koujiMenseki[i + 1] = aData.koujiMenseki[i + 1];
          }
          pinfo.roomCount = aData.roomCount;
          pinfo.roomType = aData.roomType;
          pinfo.genkanhoko = aData.genkanhoko;
          pinfo.maguchi = aData.maguchi;
          pinfo.okuyuki = aData.okuyuki;

          cb(pinfo, '');
        }
      }
    };
    const unsuccess = (msg: string) => {
      if (cb != null) {
        const pinfo = new marietta3d.AutoGen.PlanAreaInfo();
        cb(pinfo, msg);
      }
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/plan_info', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] Area info
  */
  public ReqEstimate(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;

    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (jsonData: any) => {
      if (jsonData != null) {
        aData.InitAreaInfo(); // 初期化
        const pinfo: marietta3d.AutoGen.PlanEstimate = new marietta3d.AutoGen.PlanEstimate();
        // Info 読み込み
        const info = jsonData.sekisan;
        if (info != null) {
          for (let i = 0; i < info.length; i += 1) {
            const item = new marietta3d.AutoGen.EstimateValue();
            item.code = info[i].code;
            item.name = info[i].name;
            item.unit = info[i].unit;
            item.value = info[i].value;
            pinfo.gaibu.push(item);
          }
        }
        const rooms = jsonData.room_sekisan;
        if (rooms != null) {
          for (let i = 0; i < rooms.length; i += 1) {
            const flr = Number(rooms[i].floor);
            const estItem = rooms[i].est_room;
            if (estItem != null) {
              for (let j = 0; j < estItem.length; j += 1) {
                const ritem = estItem[j];
                const itemAry = new marietta3d.AutoGen.RoomEstimate();
                for (let ric = 0; ric < ritem.length; ric += 1) {
                  const item = new marietta3d.AutoGen.EstimateValue();
                  item.code = ritem[ric].code;
                  item.name = ritem[ric].name;
                  item.unit = ritem[ric].unit;
                  item.value = ritem[ric].value;
                  itemAry.estimate.push(item);
                }
                pinfo.naibu[flr - 1].push(itemAry);
              }
            }
          }
        }

        if (cb != null) {
          cb(pinfo, '');
        }
      }
    };
    const unsuccess = (msg: string) => {
      if (cb != null) {
        const pinfo = new marietta3d.AutoGen.PlanEstimate();
        cb(pinfo, msg);
      }
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/plan_estimate', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] Dimension
  */
  public ReqDimension(cb: Function, flr: number, sc: marietta3d.AutoGen.Scale) {
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    /*
      if ( aData.reqDim == false ) {
          aData.reqDim = true;
      } else {
          if ( cb != null ) {
              cb( aData.DimensionList );
          }
          return;
      }
      */
    // リクエスト用データ
    const reqXML = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    aData.InitDimensionList(); // 初期化
    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (jsonData: any) => {
      if (jsonData != null) {
        if (jsonData.status && jsonData.status === 'SUCCESS') {
          // Dim 読み込み
          aData.perseDimension(jsonData, sc);
        }
        if (cb != null) {
          cb(aData.DimensionList, '');
        }
      }
      aData.reqDim = false;
    };
    const unsuccess = (msg: string) => {
      if (cb != null) {
        cb(aData.DimensionList, msg);
      }
      aData.reqDim = false;
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/model_dim', reqXML, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] Dimension3D
  */
  public ReqDimension3D(cb: Function, flr: number, sc: marietta3d.AutoGen.Scale) {
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    /*
      if ( aData.reqDim == false ) {
          aData.reqDim = true;
      } else {
          if ( cb != null ) {
              var ary = new Array();
              cb( ary );
          }
          return;
      }
      */
    aData.InitDimensionList(); // 初期化
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (xmlDoc: Document) => {
      if (xmlDoc != null) {
        const exp = xmlDoc.getElementsByTagName('plan');
        if (exp.length > 0) {
          // Dim 読み込み
          aData.perseDimension(exp, sc);
        }
        if (cb != null) {
          const ary = [];
          ary.push([[]]);
          ary.push([]);
          ary.push([]);
          for (let f = 0; f < 3; f += 1) {
            for (let i = 0; i < aData.DimensionList[f].length; i += 1) {
              const dim: marietta3d.AutoGen.object.AutoObjDimension = aData.DimensionList[f][i];
              const p1 = sc.ConvertTo3DModelFromWebCAD(dim.p1);
              const p2 = sc.ConvertTo3DModelFromWebCAD(dim.p2);
              const p1w = sc.ConvertTo3DModelFromWebCAD(dim.p1w);
              const p2w = sc.ConvertTo3DModelFromWebCAD(dim.p2w);
              const wdim = new marietta3d.AutoGen.object.AutoObjDimension(f + 1, p1, p2, p1w, p2w, dim.dimStr);
              ary[f].push(wdim);
            }
          }
          cb(ary);
        }
      }
      aData.reqDim = false;
    };
    const unsuccess = () => {
      if (cb != null) {
        const ary = [];
        ary.push([]);
        ary.push([]);
        ary.push([]);
        cb(ary);
      }
      aData.reqDim = false;
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/model_dim', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] プランSVGのPNG画像生成 Request
  */
  public ReqSvgThumbnail(cb: Function, floor: number, sizex: number, sizey: number, format: number, minmap: number) {
    const reqJson = JSON.parse(marietta.webcad.util.WebcadJSONExporter.createWebCADData());
    const url = `api/image?floor=${floor.toString()}&sizex=${sizex.toString()}&sizey=${sizey.toString()}&minmap=${minmap.toString()}&image=${format.toString()}`;

    // const aData: marietta3d.AutoGen.autoBase = this.autoGen;
    // リクエストの結果、戻ってきたPNGの読み込み用クロージャ
    const success = (png: any) => {
      cb(png, '');
    };
    const unsuccess = (msg: string) => {
      cb(null, msg);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequestData(url, JSON.stringify(reqJson), success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] 自動屋根 Request
  */
  public ReqAutoRoof(cb: Function) {
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    // リクエストの結果、戻ってきたJsonの読み込み用クロージャ
    const success = (jsonData: any) => {
      if (jsonData != null) {
        const stat = jsonData.status;
        let msg: string = '';
        if (jsonData.message != null) {
          if (jsonData.message.length > 0) {
            msg = jsonData.message[0];
          }
        }
        if (stat === 'SUCCESS') {
          // 屋根読み込み
          const roof = jsonData.roof;
          if (roof != null) {
            if (roof.length > 0) {
              aData.InitRoofList(); // 屋根初期化
              aData.readRoof(roof, jsonData.building_type);

              cb(aData.RoofList, '');
            }
          }
        } else {
          aData.InitRoofList(); // 屋根初期化
          cb(aData.RoofList, msg);
        }
      }
    };
    const unsuccess = (msg: string) => {
      aData.InitRoofList(); // 屋根初期化
      cb(aData.RoofList, msg);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/generate_roof2d', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] 3D Request
  */
  public Req3D(start3D: Function, cbTimeout: Function, sc: marietta3d.AutoGen.Scale) {
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    aData.InitDimensionList(); // 初期化
    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (request: XMLHttpRequest) => {
    // const success = (xmlDoc: Document) => {
      const jsonData = request.response.json();
      if (jsonData != null) {
        const dae = jsonData.COLLADA;
        let ermsg: string = '';
        const asset = dae.asset;
        if (asset.length > 0) {
          const contr = asset.contributor;
          if (contr.length > 0) {
            const psize = contr.plan_size;
            if (psize.length > 0) {
              const psx = psize.size_x;
              const psy = psize.size_y;
              aData.planSizeX = Number(psx);
              aData.planSizeY = Number(psy);
            } else {
              aData.planSizeX = 0;
              aData.planSizeY = 0;
            }
            const phigh = contr.plan_high_param;
            aData.Model.readHeightXML(phigh);

            const message = contr.message;
            if (message.length > 0) {
              ermsg = message[0];
              ermsg = ermsg.replace(/\n/g, '<br>');
            }
          }
        }
        const exp = jsonData.plan_dimension;
        if (exp.length > 0) {
          // Dim 読み込み
          aData.perseDimension(exp, sc);
        }
        const DimAry = [];
        DimAry.push([]);
        DimAry.push([]);
        DimAry.push([]);
        for (let f = 0; f < 3; f += 1) {
          for (let i = 0; i < aData.DimensionList[f].length; i += 1) {
            const dim: marietta3d.AutoGen.object.AutoObjDimension = aData.DimensionList[f][i];
            const p1 = sc.ConvertTo3DModelFromWebCAD(dim.p1);
            const p2 = sc.ConvertTo3DModelFromWebCAD(dim.p2);
            const p1w = sc.ConvertTo3DModelFromWebCAD(dim.p1w);
            const p2w = sc.ConvertTo3DModelFromWebCAD(dim.p2w);
            const wdim = new marietta3d.AutoGen.object.AutoObjDimension(f + 1, p1, p2, p1w, p2w, dim.dimStr);
            DimAry[f].push(wdim);
          }
        }

        start3D(request, aData.planSizeX, aData.planSizeY, aData, DimAry, ermsg);
        // start3D(xmlDoc, aData.planSizeX, aData.planSizeY, aData, DimAry, ermsg);
      }
    };
    const unsuccess = (msg: string) => {
      if (msg.indexOf('ただいま大変混み合っております') >= 0) {
        cbTimeout();
      } else {
        const DimAry = [];
        DimAry.push([]);
        DimAry.push([]);
        DimAry.push([]);

        start3D(null, 0, 0, aData, DimAry, msg);
      }
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/model_3d', reqJson, success, unsuccess);
  }

  /*------------------------------------------------------
>>>>>>> WEBCADV15-198
  * [ASP] 3D Images Request
  */
  public Req3DImages(start3D: Function, cbTimeout: Function, sc: marietta3d.AutoGen.Scale) {
    const reqXML = this.autoGen.reqXML();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;
    aData.InitDimensionList(); // 初期化
    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (xmlDoc: Document) => {
      console.log(xmlDoc);
    };
    const unsuccess = (msg: string) => {
      console.log(msg);
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('ModelElevation', reqXML, success, unsuccess);
  }

  /*------------------------------------------------------
  * [ASP] Web Request
  */
  public webRequest(IISName: string, reqXML: string, success: Function, unsuccess: Function) {
    let httpRequest: any = null; // リクエスト用クロージャ内で参照。
    let xmlDoc = null;
    // エラー通知用のＸＭＬ
    // var s1 = '<?xml version="1.0" encoding="utf-8"?>'
    // const s1 = '< COLLADA xmlns= "http://www.collada.org/2005/11/COLLADASchema" version= "1.4.1" >'
    //   + '<asset>'
    //   + '<created>2016/08/04 11:55:09</created>'
    //   + '<modified>2016/08/04 11:55:09</modified>'
    //   + '<up_axis>Z_UP</up_axis>'
    //   + '<contributor>'
    //   + '<status>unsuccess< /status>'
    //   + '<message>';
    // const s2 = '</message>'
    //   + '</contributor>'
    //   + '</asset>'
    //   + '</COLLADA>';
    // const parser = new DOMParser();
    let timeout = false;
    const funcTimeout = () => {
      timeout = true;
      // var xml = s1 + " 受信タイムアウト " + s2;
      // xmlDoc = parser.parseFromString( xml, 'text/xml' );
      const xml: string = 'ただいま大変混み合っております。<br>しばらくしてからお試し下さい。';
      unsuccess(xml);
    };
    // var id = setTimeout(funcTimeout, 30000);
    const funcDeleteReq = () => {
      const r = httpRequest.getAllResponseHeaders();
      if (httpRequest != null) {
        // delete httpRequest;
        httpRequest = null;
      }
    };

    // リクエストに対する、サーバーからのレスポンスを受けるクロージャ（非同期）
    const processResponse = () => {
      if (timeout === true) {
        if (httpRequest != null) {
          // delete httpRequest;
          httpRequest = null;
        }
      } else if (httpRequest.readyState === 4) { // 2:送信済3:受信中 4:受信済
        // 受信終了
        // clearTimeout(id);
        if (httpRequest.status === 200 || httpRequest.status === 201) {
        //   リクエストの処理
          const doc = JSON.parse(httpRequest.response);
          if (doc != null) {
            const dae = doc.dae;
            const plan = doc.plan;
            const exp = doc.export;
            const webcad = doc.webcad;
            const fittingList = doc.fitting_list;
            const fittingSizeList = doc.fitting_size_list;
            const fittingDefaultSet = doc.fittingDefaultSet;

            if (doc.status === 'SUCCESS') {
              xmlDoc = doc;
              success(xmlDoc);
            } else {
              // var xml = s1 + " 計算エラー " + s2;
              // var xml: string = "ただいま大変混み合っております。/しばらくしてからお試し下さい。";
              let xml: string = '';
              const response = JSON.parse(httpRequest.response);
              if (response.message.length > 0) {
                let msg: string = '';
                const nodeJa = response.message[0].text_ja;
                if (nodeJa !== undefined && nodeJa !== null) {
                  msg = nodeJa;
                }
                if (msg.length > 0) {
                  // 改行を変換
                  xml = msg.replace(/\r?\n/g, '<br>');
                } else {
                  xml = 'XML error.';
                }
              } else {
                xml = 'XML error.';
              }
              // xmlDoc = parser.parseFromString( xml, 'text/xml' );
              unsuccess(xml);
            }
            funcDeleteReq();

            // if (IISName === 'Model') this.test = httpRequest;
            if (dae && dae.length > 0) {
              xmlDoc = doc;
              success(httpRequest);
              funcDeleteReq();
              return;
            }
            if (exp && exp.length > 0) {
              xmlDoc = doc;
              success(httpRequest);
              funcDeleteReq();
              return;
            }
            if (webcad && webcad.length > 0) {
              xmlDoc = doc;
              success(httpRequest);
              funcDeleteReq();
              return;
            }
            if (fittingList && fittingList.length > 0) {
              xmlDoc = doc;
              success(httpRequest);
              funcDeleteReq();
              return;
            }
            if (fittingSizeList && fittingSizeList.length > 0) {
              xmlDoc = doc;
              success(httpRequest);
              funcDeleteReq();
              return;
            }
            if (fittingDefaultSet && fittingDefaultSet.length > 0) {
              xmlDoc = doc;
              success(httpRequest);
              funcDeleteReq();
            }
            /*
                          } else if ( httpRequest.status == 408 ) {
                              var xml = s1 + "ServerResponse:" + httpRequest.status.ToString()+ s2;
                              //var xml: string = "ただいま大変混み合っております。/しばらくしてからお試し下さい。";
                              //xmlDoc = parser.parseFromString( xml, 'text/xml' );
                              unsuccess( xml );
                              */
          }
        } else {
          // var xml = s1 + "ServerResponse:" + httpRequest.status.ToString()+ s2;
          // var xml: string = "ただいま大変混み合っております。/しばらくしてからお試し下さい。";
          let xml: string = '';
          if (httpRequest.status === 500) {
            xml = 'ただいま大変混み合っております。<br>しばらくしてからお試し下さい。';
          } else if (Math.floor((httpRequest.status) / 100) === 4 || httpRequest.status === 0) {
            // 通信エラー
            xml = 'ネットワーク環境に問題があるため、<br>ネットワーク環境が良い場所から再度リトライしてください。';
          } else {
            xml = `Error. (${httpRequest.status.toString()})`;
          }
          // xmlDoc = parser.parseFromString( xml, 'text/xml' );
          unsuccess(xml);
          funcDeleteReq();
        }
      }
    };
    httpRequest = new XMLHttpRequest();
    /*
      if ( window.XDomainRequest ) {
          // IE 8
          httpRequest = new XDomainRequest();
      } else if ( window.XMLHttpRequest ) {
          // Firefox, Opera など
          httpRequest = new XMLHttpRequest();
          // httpRequest.overrideMimeType( 'text/xml' );
      } else if ( window.ActiveXObject ) {
          // IE
          try {
              httpRequest = new ActiveXObject( 'Msxml2.XMLHTTP' );
          } catch ( e ) {
              httpRequest = new ActiveXObject( 'Microsoft.XMLHTTP' );
          }
      }
      */
    const url = this.autoGen.apiUrlPath;
    httpRequest.open('POST', `${url + IISName}`, true);
    httpRequest.setRequestHeader('Content-Type', 'application/json');
    httpRequest.timeout = 30000;
    // httpRequest.open( 'POST', 'http://111.171.206.197/WebAPI/' + IISName + '.aspx', true );
    // httpRequest.open( 'POST', 'http://localhost:1794/' + IISName + '.aspx', true );
    httpRequest.onreadystatechange = processResponse;
    httpRequest.send(reqXML);
    // $.ajax({
    //   type: 'post',
    //   url: 'https://webcad-test.marietta.co.jp/webcad15app/cadapi6/api/model_dim',
    //   data: JSON.stringify(reqXML),
    //   contentType: 'application/json; charset=UTF-8',
    //   dataType: 'json',
    //   success(info) {

    //   },
    //   error() {

    //   },
    //   complete(xhr, status) {

    //   },
    // });
  }

  /*------------------------------------------------------
  * [ASP] Web Request Data
  */
  public webRequestData(IISName: string, reqXML: string, success: Function, unsuccess: Function) {
    let httpRequest: any = null; // リクエスト用 クロージャ内で参照。
    let timeout = false;
    const funcTimeout = () => {
      timeout = true;
      const xml: string = 'ただいま大変混み合っております。<br>しばらくしてからお試し下さい。';
      unsuccess(xml);
    };
    // var id = setTimeout(funcTimeout, 30000);

    // リクエストに対する、サーバーからのレスポンスを受けるクロージャ（非同期）
    const processResponse = () => {
      if (timeout === true) {
        if (httpRequest != null) {
          // delete httpRequest;
          httpRequest = null;
        }
      } else if (httpRequest.readyState === 4) { // 2:送信済 3:受信中 4:受信済
        // 受信終了
        // clearTimeout(id);
        if (httpRequest.status === 200 || httpRequest.status === 201) {
          // リクエストの処理
          const data = JSON.parse(httpRequest.response);
          if (data.status === 'SUCCESS') {
            success(data);
          } else {
            unsuccess(data.message[0]);
          }
        } else {
          let xml: string = '';
          if (httpRequest.status === 500) {
            xml = 'ただいま大変混み合っております。<br>しばらくしてからお試し下さい。';
          } else if (Math.floor((httpRequest.status) / 100) === 4 || httpRequest.status === 0) {
            // 通信エラー
            xml = 'ネットワーク環境に問題があるため、<br>ネットワーク環境が良い場所から再度リトライしてください。';
          } else {
            xml = `Error. (${httpRequest.status.toString()})`;
          }
          unsuccess(xml);
        }
        const r = httpRequest.getAllResponseHeaders();
        if (httpRequest != null) {
          // delete httpRequest;
          httpRequest = null;
        }
      }
    };
    httpRequest = new XMLHttpRequest();
    const url = this.autoGen.apiUrlPath;
    httpRequest.open('POST', `${url + IISName}`, true);
    httpRequest.setRequestHeader('Content-Type', 'application/json');
    httpRequest.timeout = 30000;
    httpRequest.onreadystatechange = processResponse;
    httpRequest.send(reqXML);
  }


  /*------------------------------------------------------
  * [ASP] 見積情報の取得
  */
  public ReqStartsQuotationList(cb: Function) {
    // リクエスト用データ
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const aData: marietta3d.AutoGen.AutoBase = this.autoGen;

    // リクエストの結果、戻ってきたXMLの読み込み用クロージャ
    const success = (jsonData:StartsQuotationList) => {
      if (jsonData != null) {
        if (cb != null) {
          cb(jsonData, '');
        }
      }
    };
    const unsuccess = (msg: string) => {
      if (cb != null) {
        cb(null, msg);
      }
    };
    // 読み込みクロージャを引数に指定してASPへのリクエスト
    this.webRequest('api/plan_starts_estimate', reqJson, success, unsuccess);
  }
}
